import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import * as yup from "yup";
import { Typography } from "@mui/material";

const initialValues = {
  time: "",
};
const onFormSubmit = async (values) => {
 
};
const validateTimeForm = yup.object().shape({
  time: yup.number().required(" Grace time is required"),
});

export default function DialogChange({
  open,
  handleClose,
  onChangeAddExpiry,
  Cancelationperiod,
  updateExpiryDate,
  errorMassage,
}) {
  const [period, setPeriod] = React.useState("");

  
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => onFormSubmit(values)}
        validationSchema={validateTimeForm}
      >
        {({ handleBlur, values }) => (
          <>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogTitle
                id="responsive-dialog-title"
                sx={{
                  height: "19px",
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "14px",
                  lineHeight: "15px",
                  display: "flex",
                  alignItems: "center",
                  color: "#111111",
                  marginTop: "1.2rem",
                }}
              >
                {"Enter waiting time"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <input
                    placeholder="Time"
                    onChange={(e) => {
                      onChangeAddExpiry("cancle", e.target.value);
                      setPeriod(e.target.value);
                    }}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 2);
                    }}
                    defaultValue={Cancelationperiod}
                    style={{
                      padding: "10px 15px",
                      width: "300px",
                      height: "25px",
                      background: "#FFFFFF",
                      border: "1px solid #EBEBEB",
                      borderRadius: "6px",
                    }}
                    onBlur={handleBlur("time")}
                  ></input>
                </DialogContentText>

                <Typography sx={{ color: "red", fontSize: "15px" }}>
                  {errorMassage}
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  sx={{
                    background: "#04AAD",
                    marginRight: "1rem",
                    width: "100.17px",
                    height: "40px",
                    marginBottom: "1.2rem",
                    cursor: "pointer",
                  }}
                  onClick={() => updateExpiryDate()}
                  disabled={!period}
                >
                  UPDATE
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Formik>
    </>
  );
}
